// extracted by mini-css-extract-plugin
export default {"single_rreview_tab":"awating-confirmation-website_single_rreview_tab__bxJh6"};